
import React from 'react';
import { Card } from "@/components/ui/card";
import { SlidersVertical } from "lucide-react";

interface SliderControlProps {
  sliderValue: number;
  onSliderChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const SliderControl: React.FC<SliderControlProps> = ({
  sliderValue,
  onSliderChange
}) => {
  return (
    <div className="flex flex-col items-center justify-center w-12 py-4 bg-secondary/60 rounded-lg border border-primary/20 mr-1">
      <div className="flex flex-col items-center mb-2">
        <SlidersVertical size={16} className="text-primary-light mb-1" />
        <span className="text-xs text-primary-light rotate-90 whitespace-nowrap"></span>
      </div>
      <div className="h-[320px] flex items-center justify-center relative">
        <div className="absolute h-[300px] w-[2px] bg-primary-light/30 rounded-full"></div>
        <input 
          type="range" 
          min="0" 
          max="95" 
          value={sliderValue} 
          onChange={onSliderChange} 
          className="h-[300px] -rotate-90 bg-inherit appearance-none w-[300px] rounded-lg cursor-pointer" 
          style={{
            accentColor: '#10B981'
          }} 
        />
      </div>
      <div className="text-center mt-2">
        <span className="text-xs text-primary-light">{sliderValue}%</span>
      </div>
    </div>
  );
};
